export enum PrinterConnectionType {
  STAR_CLOUDPRNT = 'STAR_CLOUDPRNT',
  EPSON_SDP = 'EPSON_SDP',
}

export enum PrinterManufacturer {
  STAR = 'STAR',
  EPSON = 'EPSON',
}

export enum PrinterModel {
  TM_M30III = 'TM_M30III',
  STAR_GENERIC = 'STAR_GENERIC',
}

export enum PrinterPaperWidth {
  MM_58 = 58,
  MM_80 = 80,
}

export enum PrinterPrintType {
  TEST = 'TEST',
  BOOKING = 'BOOKING',
  TICKET = 'TICKET',
  CHECK_IN = 'CHECK_IN',
  MANUAL = 'MANUAL',
}

/** Heartbeat window for deriving online status from lastSeenAt (ms). */
export const PRINTER_ONLINE_HEARTBEAT_MS = 120_000

export const EPSON_SDP_DIGEST_REALM = 'TablelistPrinter'
